import React, { useEffect, useState, useRef } from "react";
import Primarytheme from './theme';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from "@mui/material/Tooltip";


import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import statiRiconosciuti from '../helpers/statiRiconosciuti';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';

import IconButton from '@mui/material/IconButton';

import ListItem from '@mui/material/ListItem';
import Chip from '@mui/material/Chip';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import DescriptionIcon from '@mui/icons-material/Description';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import TimelineIcon from '@mui/icons-material/Timeline';
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from '@mui/icons-material/Close';

import AttentionBlock from './AttentionBlock';
import Timer from "./Timer";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import axios from 'axios';
import { getFileFromS3 } from '../helpers/operations';

import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridPrintExportMenuItem,
  GridCsvExportMenuItem,
  GridToolbarExportContainer,
  gridExpandedRowCountSelector,
} from '@mui/x-data-grid';
import { ListItemButton, Pagination } from "@mui/material";

//icons
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';





import { getSessionIdToken } from '../auth/apiAuth'

const {
  REACT_APP_USER_ID,
} = process.env;


// STILI
const pickColor = (status) => {
  if (statiRiconosciuti.completati.has(status)) return Primarytheme.palette.secondary.main
  if (statiRiconosciuti.falliti.has(status)) return Primarytheme.palette.error.main
  if (status === 'del') return Primarytheme.palette.neutral.light
  else return Primarytheme.palette.primary.main
}

const statusIndex = (status) => {
  if (statiRiconosciuti.completati.has(status)) return '1'
  if (statiRiconosciuti.falliti.has(status)) return '2'
  if (status === 'del') return '3'
  else return '0'
}

const pickPdfColor = (status) => {
  if (status === 'pagination complete') {
    return Primarytheme.palette.neutral.dark
  } else {
    return Primarytheme.palette.neutral.light
  }
}

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  if (pageCount > 1) return (
    <Pagination
      color="primary"
      count={pageCount}
      page={page + 1}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}

    />
  )
  else return null
}

export default function RuleTable({ requestList, changeItem, user, refresh, refreshPage }) {

  // row state
  const [rows, setRows] = useState([]);

  // selected rows with checkbox
  const [selectionModel, setSelectionModel] = useState([]);
  const [deleting, setDeleting] = useState(false);

  // snackbar Share
  const [snack, setSnack] = useState({
    open: false,
    message: 'Url copied to clipboard!'
  })

  // dialog for print
  const [dialogExportOpenPrint, setDialogExportOpenPrint] = useState(false);

  const handleDialogExportOpenPrint = () => {
    setDialogExportOpenPrint(true);
  };

  const handleDialogExportClosePrint = () => {
    setDialogExportOpenPrint(false);
  };

  const handleStopProcess = async ({ keyList }) => {
    const token = await getSessionIdToken();
    for (const req of keyList) {
      const reqId = req.split('###')[0];
      const bucket = req.split('###')[1];
      const project_id = req.split('###')[2];
      setDeleting(true);
      axios.delete(`${process.env.REACT_APP_API_BASE_URL}/operations`, {
        headers: {
          "Authorization": token,
          reqId,
          project_id,
          bucket,
          user_id: 'web-app'
        }
      })
        .then(response => {
          // console.log('stop response', response.data);
          refreshPage();
        }).catch(err => { }) // console.log(err))
    }

  }

  const CustomToolbar = () => {
    const apiRef = useGridApiContext();
    const filterRows = useGridSelector(apiRef, gridExpandedRowCountSelector);

    return (


      <Stack id='customToolbar' direction='row' spacing={3} justifyContent='flex-end' alignItems='center' >
        <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems='center' >
          <GridToolbarFilterButton sx={{ pt: 0.3, pb: 0.3, color: Primarytheme.palette.neutral.main, ":hover": { color: Primarytheme.palette.primary.main }, border: '1px solid' }} />
          <GridToolbarExportContainer sx={{ pt: 0.3, pb: 0.3, color: Primarytheme.palette.neutral.main, ":hover": { color: Primarytheme.palette.primary.main }, border: '1px solid' }}>
            <GridCsvExportMenuItem
              options={{
                allColumns: true,
                fields: ['filename', 'reqId', 'startTime', 'statusDesc', 'user', 'projectidDesc', 'tags']
              }}
            />
            {(filterRows > 100) && (
              <MenuItem onClick={handleDialogExportOpenPrint}>
                <Typography>
                  Print
                </Typography>

                {/*  Print */}
              </MenuItem>
            )}
            {(filterRows <= 100) && (
              <GridPrintExportMenuItem
                options={{
                  allColumns: true,
                  fields: ['filenameShort', 'reqId', 'startTimeShort', 'statusDesc', 'user', 'projectidDesc', 'tags'],
                  hideFooter: true,
                  hideToolbar: true,
                }}
              />
            )}

          </GridToolbarExportContainer>
        </Stack>
      </Stack>


    );
  }

  const renderTagsCell = (gridRowParams) => {
    const tags = gridRowParams.value; // Assuming tags is an array of strings
    const typoChipSx = { fontSize: 13, whiteSpace: 'normal', /* mt: '0.1em', mb: '0.1em' */ };
    const chipSx = { variant: "outlined", size: "small" };
    return (
      <Stack id='projectIdChips' direction='column' >
        {tags.map((tag, index) => (
          tag && <Chip key={index} sx={{ height: "auto", minWidth: "auto", wordBreak: "break-word", m: "0.1em", maxWidth: "100%" }}
            label={<Typography sx={typoChipSx}>{tag}</Typography>}
            {...chipSx}
            color={index === 0 ? 'warning' : undefined}
          />
        ))}
      </Stack>
    );
  };

  const renderPTime = (req) => {
    //console.log(req.value)
  
    return (

      < CustonProgress
        req={req.value}
        user={user}
      />

    )
  }
  const listInfo = (infoParams) => {
    const params = infoParams.value;
    return (
      <List dense={true} disablePadding={true}>
        {params.map((param, index) => (
          <ListItem key={index} dense={true} sx={{ padding: '0' }} >
            <ListItemIcon sx={{ minWidth: '0', mr: '0.5em' }}>
              {index == 0 ? <InfoIcon fontSize='small' color="disabled" /> : <PersonIcon fontSize='small' color="disabled" />}
            </ListItemIcon>
            <Typography component="div" variant="caption" color="textSecondary">{param}</Typography>
          </ListItem>
        ))}
      </List>

    )
  }
  const dateInTable = (gridRowParams) => {
    const tag = gridRowParams.value;
    return (
      <Typography variant='caption' color='textSecondary' component='div' mt='0.5em'>
        {(new Date(tag)).toLocaleString().replace(/T/, ' ').replace(/\..+/, '')}
      </Typography>
    )
  }
  const dateShortInTable = (gridRowParams) => {
    const tag = gridRowParams.value;
    return (
      (new Date(tag)).toLocaleString().replace(/T/, ' ').replace(/\..+/, '')
    )
  }
  const fileNameinTable = (fileName) => {
    const filename = fileName.value
    return (
      <Typography variant="inherit" sx={{ wordBreak: "break-word" }}>
        <strong>{filename}</strong>
      </Typography>
    )
  }

  const adminIconList = (req) => {

    const handleJumpS3Out = () => {
      window.open(`https://s3.console.aws.amazon.com/s3/buckets/${req.value.bucket}?region=eu-west-1&prefix=${req.value.project_id}/output/${req.value.reqId}/`);
    }
    const handleJumpS3Split = () => {
      window.open(`https://s3.console.aws.amazon.com/s3/buckets/${req.value.bucket}?region=eu-west-1&prefix=split/${req.value.project_id}/data-webapp/${req.value.reqId}/`);
    }

    const handleKibanaLog = () => {
      window.open(`http://dragon.pagination.com:5601/app/kibana#/discover/ab1735b0-ba02-11ee-ae3b-7de6523212fb?_g=(filters:!(),refreshInterval:(pause:!t,value:5000),time:(from:now-15m,to:now))&_a=(columns:!(type,payload.sourcedata,'@reqid','@instance'),filters:!(('$state':(store:appState),meta:(alias:types,disabled:!t,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:type.keyword,negate:!f,params:!(pagination-complete,data-integration-response,script-error,runner-error,job-complete,request-received,specific-error,end-split-statistic),type:phrases,value:'pagination-complete,%20data-integration-response,%20script-error,%20runner-error,%20job-complete,%20request-received,%20specific-error,%20end-split-statistic'),query:(bool:(minimum_should_match:1,should:!((match_phrase:(type.keyword:pagination-complete)),(match_phrase:(type.keyword:data-integration-response)),(match_phrase:(type.keyword:script-error)),(match_phrase:(type.keyword:runner-error)),(match_phrase:(type.keyword:job-complete)),(match_phrase:(type.keyword:request-received)),(match_phrase:(type.keyword:specific-error)),(match_phrase:(type.keyword:end-split-statistic)))))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:'@reqid.keyword',negate:!t,params:(query:vscode),type:phrase,value:vscode),query:(match:('@reqid.keyword':(query:vscode,type:phrase)))),('$state':(store:appState),meta:(alias:'errors%20only',disabled:!t,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:'@level',negate:!f,params:(query:'5'),type:phrase,value:'5'),query:(match:('@level':(query:'5',type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:tags,negate:!t,params:(query:ids-log),type:phrase,value:ids-log),query:(match:(tags:(query:ids-log,type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:'@reqid',negate:!f,params:(query:'${req.value.reqId}'),type:phrase,value:'${req.value.reqId}'),query:(match:('@reqid':(query:'${req.value.reqId}',type:phrase))))),index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',interval:auto,query:(language:kuery,query:''),sort:!('@timestamp',desc))`);
    }

    return (
      <Stack direction='row'>

        <Tooltip title="Output folder in S3">
          <IconButton onClick={handleJumpS3Out} size='small' sx={{ color: Primarytheme.palette.neutral.dark }}>
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </Tooltip>


        <Tooltip title="Split folder in S3">
          <IconButton onClick={handleJumpS3Split} size='small' sx={{ color: Primarytheme.palette.neutral.dark }}>
            <AccountTreeIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Kibana">
          <IconButton onClick={handleKibanaLog} size='small' sx={{ color: Primarytheme.palette.neutral.dark }}>
            <TimelineIcon fontSize="small" />
          </IconButton>
        </Tooltip>


      </Stack>
    )
  }

  const mainIconList = (req) => {
    return (
      <Stack direction='row' justifyContent={'center'}>
        <Tooltip title="Download Datafile">
          <IconButton size="small" onClick={() => getFileFromS3({ key: `${req.value.project_id}/${req.value.origin}`, bucket: req.value.bucket, customBucket: req.value.bucket, attachment: true, ssmParams: user.ssmParams })}
            disabled={req.value.disableDatafile}
            sx={{ color: Primarytheme.palette.neutral.dark }} >
            < DescriptionIcon fontSize="small" />
          </IconButton>
        </ Tooltip >
      </Stack>
    )
  }

  const renderPaginationTest = (req) => {
    const handleMakePublic = async () => {
      setDeleting(true);
      axios({
        method: "patch",
        url: `${process.env.REACT_APP_API_BASE_URL}/projects-webapp`,
        headers: {
          "reqid": req.value.reqId,
          "project_id": req.value.project_id,
          "content-type": "application/json",
          "Authorization": await getSessionIdToken(),
        },
        data: {
          internalTest: false
        }
      })
        .then(response => { refreshPage() })
        .then(() => setDeleting(false))
        .catch(err => {
          // console.log(err)
        })
    }
    return (
      <>
        {req.value.internalTest && <ListItem><Chip label='test' variant="outlined" size="small" color='warning' onDelete={() => handleMakePublic()} />  </ListItem>}
      </>
    )
  }

  const sortObjinTable = (a, b, field) => {
    if (field === 'chip') {
      const aLabel = a[0];
      const bLabel = b[0];

      return aLabel.localeCompare(bLabel);
    } else if (field === 'date') {
      return new Date(a) - new Date(b)

    } else if (field === 'status') {
      const aTags = statusIndex(a.status);
      const bTags = statusIndex(b.status);
      return aTags.localeCompare(bTags);
    }
    else {
      const aTags = a;
      const bTags = b;
      return aTags.localeCompare(bTags);
    }
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ open: false, launchMessage: '' });
  };

  const columns = [
    {
      field: 'status',
      headerName: 'Status',
      flex: 3,
      renderCell: renderPTime,
      align: 'left',
      sortComparator: (a, b) => sortObjinTable(a, b, 'status')
    },
    {
      field: 'filename',
      headerName: 'Filename',
      flex: 10,
      sortComparator: (a, b) => sortObjinTable(a, b),
      renderCell: fileNameinTable,
    },
    {
      field: 'startTime',
      headerName: 'Start time',
      flex: 4,
      renderCell: dateInTable,
      sortComparator: (a, b) => sortObjinTable(a, b, 'date'),

    },
    {
      field: 'projectId',
      headerName: 'project Id',
      flex: 5,
      renderCell: renderTagsCell,
      sortComparator: (a, b) => sortObjinTable(a, b, 'chip'),
    },
    {
      field: 'info',
      headerName: 'Info',
      flex: 8,
      sortable: false,
      //sortComparator: (a, b) => sortObjinTable(a, b),
      renderCell: listInfo

    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 2,
      editable: false,
      sortable: false,
      renderCell: mainIconList
    },
    // only for csv export
    {
      field: 'filenameShort',
      headerName: 'Filename',
      flex: 7,
      maxWidth: 180,
    },
    {
      field: 'startTimeShort',
      headerName: 'Start time',
      flex: 4,
      maxWidth: 120,
      renderCell: dateShortInTable,
    },
    {
      field: 'statusDesc',
      flex: 4,
      maxWidth: 120,
      headerName: 'Status Description',
    },
    {
      field: 'reqId',
      flex: 7,
      maxWidth: 230,
      headerName: 'reqId',
    },
    {
      field: 'user',
      flex: 4,
      maxWidth: 170,
      headerName: 'User',
    },
    {
      field: 'projectidDesc',
      flex: 3,
      maxWidth: 150,
      headerName: 'Project Name',
    },
    {
      field: 'tags',
      flex: 1,
      maxWidth: 70,
      headerName: 'Tag',
    },
  ];
  if (user.isAdmin) {
    columns.push({
      field: 'moreActions',
      headerName: 'More Actions',
      flex: 4,
      editable: false,
      sortable: false,
      renderCell: adminIconList
    },
      {
        field: 'test',
        headerName: 'Internal Test',
        flex: 3,
        editable: false,
        sortable: false,
        renderCell: renderPaginationTest
      })
  }




  useEffect(() => {
    const newRows = [];
    // console.log('requestList init', requestList)
    for (let i = 0; i < requestList.length; i++) {
      const req = requestList[i];
      newRows.push({
        status: { ...req, user },
        id: req.reqId + '###' + req.bucket + '###' + (user.isAdmin ? req.project_id : req.project_id.split('/').pop()),
        filename: req.origin ? req.origin.split('/').pop() : 'No origin',
        startTime: new Date(req.startTime),
        projectId: [user.isAdmin ? req.project_id : req.project_id.split('/').pop(), req.tag],
        info: [req.reqId, (req.owner && req.owner.user_id) ? req.owner.user_id : req.owner],
        actions: req,
        // only for export csv
        projectidDesc: user.isAdmin ? req.project_id : req.project_id.split('/').pop(),
        user: (req.owner && req.owner.user_id) ? req.owner.user_id : req.owner,
        reqId: req.reqId,
        statusDesc: req.status,
        tags: req.tag,
        filenameShort: req.origin ? req.origin.split('/').pop() : 'No origin',
        startTimeShort: new Date(req.startTime),

      })
      if (user.isAdmin) {
        const obj = newRows.pop()
        obj['moreActions'] = req;
        obj['test'] = req;
        newRows.push(obj)
      }
    }

    setRows(newRows);
  }, [refresh, requestList]);

  return (
    <>

      <DataGrid
        key={'requestList'}
        rows={rows}
        columns={columns}
        //sortingMode="server"
        getRowHeight={() => 'auto'}
        autoHeight
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5

            }
          },
          columns: {
            columnVisibilityModel: {
              // Hide columns, the other columns will remain visible
              statusDesc: false,
              reqId: false,
              user: false,
              projectidDesc: false,
              tags: false,
              filenameShort: false,
              startTimeShort: false,
            },
          },
        }}

        pageSizeOptions={[5]}
        disableRowSelectionOnClick={true}

        onRowSelectionModelChange={(selection) => { setSelectionModel(selection); }}
        rowSelectionModel={selectionModel}

        slots={{
          toolbar: CustomToolbar,
          pagination: CustomPagination
        }}

        sx={{
          border: '0px',
          '& .MuiDataGrid-columnHeader:focus': { outline: 'none' },
          '& .MuiDataGrid-cell:focus': { outline: 'none' },
          '& .MuiDataGrid-columnHeaderCheckbox:focus': { outline: 'none' },
          '& .MuiDataGrid-cellCheckbox': { outline: 'none', color: 'red' },
          '@media print': {
            '.MuiDataGrid-main': {
              width: 'fit-content',
              fontSize: '0.7em',
              height: 'fit-content',
              overflow: 'visible',
            },
            '.MuiDataGrid-cell': {
              wordWrap: 'break-word',
            },
            '#customToolbar': {
              display: 'none'
            },
            marginBottom: 100,
          },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center', // vertical alignment
            justifyContent: 'flex-start', // horizontal alignment (optional)
          },
        }}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={snack.open}
        autoHideDuration={5000}
        onClose={handleCloseSnack}
        message={snack.message}
        action={
          <IconButton size="small" color="inherit" onClick={handleCloseSnack}>
            <CloseIcon />
          </IconButton>
        }
      />
      <Dialog
        //fullWidth={true}
        id='print'
        maxWidth={'l'}
        open={dialogExportOpenPrint}
        onClose={handleDialogExportClosePrint}
      >
        <DialogTitle>Print Error</DialogTitle>

        <DialogContent >
          <DialogContentText>Too many rows to print. The maximum number of rows that can be printed is 100.</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogExportClosePrint} component={'label'}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}





function getProgress({
  eta, ignoreEta = false,
  pesoBook = 1,
  peso_split = 1,
  queuedTime,
  lastQueueTimeStart,
  v_media_split,
  v_media_book,
  tempoTotaleMedioPerRiga,
  splitObj,
  queueTimePerSplitMedio = 5000,
  splitDoneObj, bookDoneObj = [],
  n_split, n_books = 0,
  startTime,
  status } = {}) {

  let progress;
  let etaRealistico = eta;

  switch (status) {
    case 'queued':
      progress = NaN;
      break;
    case 'queued validated':
      progress = 0;
      break;

    case 'pagination failed':
      progress = 0;
      break;

    case 'validation failed':
      progress = 0;
      break;

    case 'pagination complete':
      progress = 100;
      break;

    default:
      const splitDoneKeys = splitDoneObj ? Object.keys(splitDoneObj) : [];
      const bookDoneKeys = bookDoneObj ? Object.keys(bookDoneObj) : [];
      const s_fratcion = splitDoneKeys.length / n_split;
      const book_fraction = n_books > 0 ? bookDoneKeys.length / n_books : 1;
      const generic_fraction = n_books > 0 ? (bookDoneKeys.length + splitDoneKeys.length) / (n_split + n_books) : splitDoneKeys.length / n_split;

      const diffSplit = n_split - splitDoneKeys.length;
      const diffBook = n_books - bookDoneKeys.length;
      const beta = (diffSplit === 0 && n_books > 0 && diffBook === 1) ? 1000 : (4 / (diffSplit + diffBook) + 1);


      // stimo ETA realistico basandomi sugli split ancora da fare
      etaRealistico = eta; // [ms]

      // tempo passato, scevro dal tempo passato in coda e corretto a zero quando in coda
      let t_passato;


      if (status === 'queued (validated)') t_passato = (new Date().getTime() - startTime - (new Date().getTime() - lastQueueTimeStart)); // [ms]
      else if (status === 'pagination in progress - queued') t_passato = (new Date().getTime() - startTime - (new Date().getTime() - lastQueueTimeStart) - queuedTime); // [ms]
      else t_passato = (new Date().getTime() - startTime - queuedTime); // [ms]

      if (!ignoreEta && etaRealistico) {
        const t_fraction = t_passato <= etaRealistico ? t_passato / etaRealistico : 1;
        if (t_fraction === 1 && s_fratcion === 1 && bookDoneKeys.length >= n_books - 1) progress = NaN;
        else progress = 100 * (peso_split * s_fratcion + pesoBook * book_fraction + beta * t_fraction) / (beta + peso_split + pesoBook); // [%]
        //console.log(peso_split, s_fratcion, pesoBook, book_fraction, beta, t_fraction, progress)
      }
      else if (n_split === 1) {
        progress = NaN;
      }
      else {
        progress = 100 * generic_fraction; // [%]
      }


      break;
  }


  return { progress, etaRealistico }
}

function buildStatusMessage({ status, splitDoneObj, n_split, bookDoneObj, n_books }) {
  let statusMessage = '';
  statusMessage += status;

  switch (status) {
    case 'pagination complete':

      break;
    case 'pagination failed':

      break;
    case 'validation failed':

      break;
    case 'queued':
      break;

    case 'nothing to paginate':
      statusMessage += '\nPlease check if the datafile is currupted and if it is compliant to the rules';
      break;


    default:
      if (splitDoneObj) {
        statusMessage += ` - ${Object.keys(splitDoneObj).length} / ${n_split} splits`
      }
      if (bookDoneObj && n_books > 0) {
        statusMessage += ` - ${Object.keys(bookDoneObj).length} / ${n_books} books`

      }
      break;
  }

  return statusMessage
}

function CustonProgress(req, user) {

  const [singleReq, setSingleReq] = useState(req.req);
  const intervalFetch = 10000; //[ms]
  const [refetch, setRefetch] = useState(0);
  const [progressState, setProgressState] = useState({ remainingEstimated: singleReq.eta, progress: 0 });
  const [statusMessage, setStatusMessage] = useState('')

  const setIntervalFetch = () => {
    const interval = setInterval(
      () => fetchDynamoReqId({ force: false }),
      intervalFetch
    );
    return interval
  }

  const fetchDynamoReqId = async ({ force = false, type }) => {

    if (force || statiRiconosciuti.running.has(singleReq.status)) {
      axios({
        method: "get",
        url: `${process.env.REACT_APP_API_BASE_URL}/operations`,
        headers: {
          'user_id': REACT_APP_USER_ID || req.req.user.ssmParams.USER_ID,
          "content-type": "application/json",
          "Authorization": await getSessionIdToken(),
          "reqId": singleReq.reqId,
          "project_id": singleReq.project_id,

          // non usati, ma expected dalla lambda
          "project_ids": singleReq.project_id,
          "stati": 'tutti',
        }
      })
        .then(resp => {
          //console.log('fetched single ', requestParent.reqId, resp.data);
          if (type === 'patch') {
            setSingleReq(resp.data);
          }
          else if (!resp.data || resp.data === '') {
            resp.data = { ...singleReq };
            resp.data.delete = 'delete';
            setSingleReq(resp.data);


          }
          else if (statiRiconosciuti.completati.has(resp.data.status) || statiRiconosciuti.falliti.has(resp.data.status)) {
            setSingleReq(resp.data);

          }
          else {
            setSingleReq(resp.data);
            setRefetch(refetch => refetch + 1);
          }
        })
        .catch(err => { }) //console.log(err))
    }

  }

  useEffect(() => {
    if (statiRiconosciuti.running.has(singleReq.status)) {
      const interval = setIntervalFetch();
      return () => {
        clearInterval(interval);
      }
    }
  }, [singleReq.status]);


  // Recompute Progress and estimated, retrieve first tumbnails
  useEffect(() => {
    // compute progress

    const { progress, etaRealistico } = getProgress(singleReq)
    const remaining____ = etaRealistico - (etaRealistico * progress / 100); // [ms]
    setProgressState({ remainingEstimated: remaining____, progress });

    // build table for errors and warnings data int
    const statusMessageStr = buildStatusMessage(req.req);
    setStatusMessage(statusMessageStr)
  }, [singleReq.reqId, singleReq.version, refetch]);


  /*  */
  return (
    <Stack direction='row' justifyContent="flex-start" alignItems='center' spacing={0.1} >

      <Tooltip arrow enterDelay={20} placement="right"
        title={
          <Stack direction='column'>
            <Timer fetchDynamoReqId={singleReq.reqId} remainingEstimated={progressState.remainingEstimated} progress={progressState.progress} ignoreEta={singleReq.ignoreEta}
              status={singleReq.status} doOnlyValidation={singleReq.doOnlyValidation} startTime={singleReq.startTime} endTime={singleReq.paginationEndTime} />
            {statusMessage && statusMessage.split('\n').map((str, index) => (
              <Typography key={index} variant="caption" component={'div'} color="inherit" gutterBottom={false} >
                {str}
              </Typography>
            ))}
          </Stack>}
      >
        <Box sx={{ position: 'relative', alignContent: 'center', top: '0.2em' }}>
          {!statiRiconosciuti.falliti.has(singleReq.status) &&
            <>
              <CircularProgress
                key={singleReq.reqId + '1'}
                sx={{ color: Primarytheme.palette.primary.light, }}
                variant="determinate"
                value={100}
                thickness={7}

              />
              <CircularProgress
                key={singleReq.reqId}
                sx={{
                  color: pickColor(singleReq.status),
                  position: 'absolute',
                  left: 0
                }}
                variant={!isNaN(progressState.progress) ? "determinate" : "indeterminate"}
                value={!isNaN(progressState.progress) ? progressState.progress : undefined}
                thickness={7}

              />
            </>
          }
        </Box>
      </Tooltip>

      {singleReq.errors && singleReq.errors.length > 0 && <AttentionBlock user={user.ssmParams} attentions={singleReq.errors} color='error' iconBBkg={Primarytheme.palette.error} type='iconButton' title='Validation errors' size='medium' sx={{ margin: 0, padding: 0 }} />}
      {statiRiconosciuti.propriofalliti.has(singleReq.status) && <AttentionBlock type='iconButton' iconBBkg={Primarytheme.palette.error} color='error' title='Process Error' size='medium' sx={{ margin: 0, padding: 0 }} notes=' An error occurred during the process. Please check that your datafile is not corrupted and that it follows the rules.' />}
      {singleReq.warnings && singleReq.warnings.length > 0 && <AttentionBlock attentions={singleReq.warnings} color='warning' type='iconButton' title='Validation warnings' size='medium' sx={{ margin: 0, padding: 0 }} />}

    </Stack>


  )
}

